import { render, staticRenderFns } from "./delete-popup.vue?vue&type=template&id=684c6130&scoped=true&"
import script from "./delete-popup.vue?vue&type=script&lang=js&"
export * from "./delete-popup.vue?vue&type=script&lang=js&"
import style0 from "./delete-popup.vue?vue&type=style&index=0&id=684c6130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684c6130",
  null
  
)

component.options.__file = "delete-popup.vue"
export default component.exports